import {ElementRef, Component, OnDestroy, AfterViewInit, ViewChild } from '@angular/core'
import { GridsterConfig, GridsterItem }  from 'angular-gridster2';
import { Subscription } from "rxjs";
import { Router } from '@angular/router'

import { InsaService, LocalizeService, AuthService } from '../../../insa-services'

import { ChartModel,
         TransactionVolumeModel,
         PortfolioPerformanceDetailsModel,
         KendoColumnListDefinition} from '../../../insa-models'
//import {KendoColumnListDefinition}  from '../../../insa-models/kendoListGenericColumnDef'       
import { appStateProvider } from '../../../insa-providers'
import { SharedMethodsModule, GenericChartsModule } from '../../../insa-custom-scripts'
import { appConfig } from '../../../../insaweb.config'
//import { setTimeout } from 'core-js/library/web/timers';

@Component({
    templateUrl: 'newHome.component.html',
    selector: 'insaweb-newhome'
})

export class NewHomeComponent implements OnDestroy, AfterViewInit {
    private transVolumeSubscription: Subscription;
    private appStateSubscription: Subscription;
    private portfPerfDetailsSubscription:Subscription;
    private performanceDetailsChartSubscription:Subscription;
    private performanceSecondSerieDescription: string;
    private scroll:string;
    private cardStyleIE:string;
    private hasPartnerOrPortfolio: boolean = false;
    private reportSubscription;

    @ViewChild('gridster') gridster;
    private gridsterOptions:GridsterConfig = {
      gridType: 'fit',
      compactType: 'none',
      initCallback: undefined,
      destroyCallback: undefined,
      itemChangeCallback: this.saveDashboardLayout.bind(this),
      itemResizeCallback: undefined,
      itemInitCallback: undefined,
      itemRemovedCallback: undefined,
      margin: 4,
      outerMargin: true,
      mobileBreakpoint: 640,
      minCols: 1,
      maxCols: 12,
      minRows: 1,
      maxRows: 8,
      maxItemCols: 100,
      minItemCols: 1,
      maxItemRows: 100,
      minItemRows: 1,
      maxItemArea: 2500,
      minItemArea: 1,
      defaultItemCols: 1,
      defaultItemRows: 1,
      fixedColWidth: 50,
      fixedRowHeight: 50,
      keepFixedHeightInMobile: false,
      keepFixedWidthInMobile: false,
      scrollSensitivity: 10,
      scrollSpeed: 20,
      enableEmptyCellClick: false,
      enableEmptyCellContextMenu: false,
      enableEmptyCellDrop: false,
      enableEmptyCellDrag: false,
      emptyCellClickCallback: undefined,
      emptyCellContextMenuCallback: undefined,
      emptyCellDropCallback: undefined,
      emptyCellDragCallback: undefined,
      emptyCellDragMaxCols: 50,
      emptyCellDragMaxRows: 50,
      draggable: {
        delayStart: 0,
        enabled: true,
        ignoreContentClass: 'gridster-item-content',
        ignoreContent: true,
        dragHandleClass: 'cardup',
        stop: undefined
      },
      resizable: {
        delayStart: 0,
        enabled: false,
        stop: undefined,
        handles: {
          s: true,
          e: true,
          n: true,
          w: true,
          se: true,
          ne: true,
          sw: true,
          nw: true
        }
      },
      // api: {
      //   resize: undefined, // this.eventStop,
      //   optionsChanged: undefined, // this.eventStop,
      //   getNextPossiblePosition: undefined, // this.eventStop,
      // },
      swap: true,
      pushItems: false,
      disablePushOnDrag: false,
      disablePushOnResize: false,
      pushDirections: {north: true, east: true, south: true, west: true},
      pushResizeItems: false,
      displayGrid: 'onDrag&Resize',
      disableWindowResize: false,
      disableWarnings: false,
      scrollToNewItems: false
    }
    // kolona 1
    private gridsterPortfolioItem:GridsterItem = {cols: 4, rows: 4, y: 0, x: 0}
    private gridsterTransactionsItem:GridsterItem = {cols: 4, rows: 4, y: 4, x: 0}
    // kolona 2
    private gridsterChartAssetItem:GridsterItem = {cols: 4, rows: 4, y: 0, x: 4}
    private gridsterCrossRatesItem:GridsterItem = {cols: 4, rows: 4, y: 4, x: 4}
    // kolona 3
    private gridsterBarPerformanceItem:GridsterItem = {cols: 4, rows: 4, y: 0, x: 8}
    private gridsterNewsItem:GridsterItem = {cols: 4, rows: 4, y: 4, x: 8}

    private gridsterItems = [
      this.gridsterPortfolioItem,
      this.gridsterChartAssetItem,
      this.gridsterBarPerformanceItem,
      this.gridsterTransactionsItem,
      this.gridsterCrossRatesItem,
      this.gridsterNewsItem
    ]

    private eventStop(item, itemComponent, event) {
      console.info('eventStop', item, itemComponent, event);
    }

    constructor(private router: Router, private _insaService: InsaService, private _appStateProvider: appStateProvider, private _localize: LocalizeService, private _element: ElementRef, private _authService: AuthService) {
        this.checkBrowserVersion();
        this.appStateSubscription = this._appStateProvider.subscribe(() => {
            this.setHasPartner();
        })
        this.transVolumeSubscription = this._insaService.TransactionsVolumeChangedEvent.subscribe(transVolume => this.refreshTransVolume(transVolume));
        this.portfPerfDetailsSubscription = this._insaService.PortfolioPerformanceDetailsEvent.subscribe(portfDetails => this.refreshPortfDetails(portfDetails));
        this.performanceDetailsChartSubscription = this._insaService.PerformanceDetailsChartEvent.subscribe(perfDetails => this.refreshPerfDetailsBarChart(perfDetails));
        this.setHasPartner();

        this.reportSubscription = this._insaService.CreateReportEvent.subscribe(() => {
          this.fixLayout()
        })
        this._authService.LoggedInStatusChangedEmitter.subscribe(loggedin => {
          // fix hiding of #wrapper padding
          this.fixLayout();
        })
    }

    saveDashboardLayout(gridsterItem, gridsterItemComponent) {
      localStorage['dashboardLayout'] = JSON.stringify(this.gridsterItems);
      return true;
    }

    loadDashboardLayout() {
      if (localStorage['dashboardLayout']) {
        let layouts = JSON.parse(localStorage['dashboardLayout']);
        this.gridsterItems.forEach((g,i) => {
          Object.assign(g, layouts[i]);
        })
        this.gridster.optionsChanged();
      }
    }

    private setHasPartner () {
        if (this._appStateProvider.selectedPartner.value !== 0 || (this._appStateProvider.selectedPortfolios && this._appStateProvider.selectedPortfolios.length > 0)) {
            this.hasPartnerOrPortfolio = true;
        } else {
            this.hasPartnerOrPortfolio = false;
        }        
    }

    private checkBrowserVersion() {
        let ua = window.navigator.userAgent;
        //for IE 11
        let ie11 = ua.indexOf('rv');
        //for IE9++
        let msie = ua.indexOf('MSIE');
        //for MS Edge
        let edge = ua.indexOf("Edge");
        let ieVer: number;
       
        if (ie11 > 0) {
            ieVer = parseInt(ua.substring(ie11 + 3, ua.indexOf('.', ie11)), 10);
        }
        if(msie > 0){
            ieVer = parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)),10);
        }
        if (ieVer >= 7 && ieVer < 13) {
            this.scroll = 'scroll';
            this.cardStyleIE = '45vh';
        }
        if(edge > -1){
            this.scroll = 'scroll';
            this.cardStyleIE = '45vh'; 
        }
    }

    private refreshTransVolume(transVolume: TransactionVolumeModel[]) {
        if (transVolume !== undefined && transVolume.length > 0) {
            this.KendoTransactionVolumeList("#TransactionVolume", transVolume, this.createTransVolumeList());
        } else {
            this.KendoTransactionVolumeList("#TransactionVolume", [], []);
        }
    }

    private refreshPortfDetails(portfDetails: PortfolioPerformanceDetailsModel[]) {
        if (portfDetails !== undefined && portfDetails.length > 0) {
            this.KendoInitAccordion(SharedMethodsModule.groupBy(portfDetails, 'Element', 'Amount'));
            $("#portfMessage").html('');
        } else {
            this.KendoInitAccordion(SharedMethodsModule.groupBy([], 'Element', 'Amount'));
            $("#portfMessage").html('<p class="center no-data-message">NO DATA</p>');
        }
    }

    private refreshPerfDetailsBarChart(perfDetails: ChartModel[]) {
        if (perfDetails !== undefined && perfDetails.length > 0) {
            let carouselOpt: CarouselOptions = {};
            carouselOpt.interval = appConfig.setCarouselTimeout;
            GenericChartsModule.KendoGenericChartList("#PerformanceDetailsList", perfDetails, this.createPerformanceDetailsList());
            this.hidePerformanceColumn();
            $('#performanceCarousel').carousel(carouselOpt);
        } else {
            GenericChartsModule.KendoGenericChartList("#PerformanceDetailsList", [], []);
        }
    }

    private hidePerformanceColumn() {
        let perfList: kendo.ui.Grid = $("#PerformanceDetailsList").data("kendoGrid");
            if (perfList !== undefined) {
                if (window.innerWidth < 1200 && appConfig.hidePerformanceChartListColumn) {
                    perfList.hideColumn(2);
                } else {
                    perfList.showColumn(2);
                }
            }
    }

    private goToCharts() {
        this.router.navigate(['/charts']);
    };

    private goToPerformance() {
        this.router.navigate(['/performance']);
    };

    private goToTransactions() {
        this.router.navigate(['/transactions']);
    };

    private goToPortfolio() {
        this.router.navigate(['/portfolio']);
    };

    private goToNews() {
        this.router.navigate(['/news']);
    };

    private goToMainWindow(){
        this.router.navigate(['/insamainwindow']);
    }

    private goToCrossRates() {
        this.router.navigate(['/crossRates']);
    }

    private KendoInitAccordion(groupedData) {
        let listViewOptions: kendo.ui.ListViewOptions = {};
        listViewOptions.dataSource = groupedData;
        listViewOptions.template = kendo.template(
            ` <div>
                <span>
                    <ul class="portfolio">
                        <li>#: Name#</li>
                        <li class="text-right">#: kendo.toString(Amount, 'n2')#</li>
                        </ul>
                  </span>
                       <div>#for(var x=0; x < SubItems.length; x++){#
                         <ul class="portfolio">
                             <li class="col-indent">#: (SubItems[x].Name!=="") ? SubItems[x].Name : "-" #</li>
                             <li class="text-right deep"> #: kendo.toString(SubItems[x].Amount, 'n2')#</li>
                          </ul>
                          #}#</div>
                       </div>`);
        listViewOptions.dataBound = function (e) {
            let panelBarOptions: kendo.ui.PanelBarOptions = {};
            panelBarOptions.expandMode = "multiple";
            $("#accordion").kendoPanelBar(panelBarOptions);
        }
        $("#accordion").kendoListView(listViewOptions);
    }

    private KendoTransactionVolumeList(selector, listData, columnDef) {
        let transVolumeOptions: kendo.ui.GridOptions = {};
        transVolumeOptions.dataSource = listData;
        transVolumeOptions.columns = columnDef;
        transVolumeOptions.scrollable = true;     
        transVolumeOptions.resizable = true;
        transVolumeOptions.noRecords = {
            template: "<p class='center no-data-message'>NO DATA</p>"
        };
         $(selector).kendoGrid(transVolumeOptions);
    }

 
    private createPerformanceDetailsList() {
        let performanceColumnDefs = new Array<KendoColumnListDefinition>();
        performanceColumnDefs.push(new KendoColumnListDefinition("Date", '#: kendo.toString(Date, "dd.MM.yyyy")#', {}, "", "Date"));
        performanceColumnDefs.push(new KendoColumnListDefinition("Value", '#: kendo.toString(Value, "n2")  + "%" #', { style: "text-align: right;" }, "", "Performance", { style: "text-align: right;" }));
        performanceColumnDefs.push(new KendoColumnListDefinition("Value2", '#: kendo.toString(Value2, "n2")  + "%" #', { style: "text-align: right;" }, "", appConfig.performanceChartSecondSerieName, { style: "text-align: right;" }));
        return performanceColumnDefs;
    }

    private createTransVolumeList() {
        let transVolumeColDef = new Array<KendoColumnListDefinition>();
        transVolumeColDef.push(new KendoColumnListDefinition("TransDescription", '#: (TransDescription!==null) ? TransDescription: "-" #', { style: 'font-weight:300;' }, "", "Trans. Description"));
        transVolumeColDef.push(new KendoColumnListDefinition("Amount", "#: kendo.toString(Amount, 'n2') #", { style: "text-align: right; font-weight: 300;" }, "", "Amount", { style: "text-align: right;" }));
        return transVolumeColDef;
    }

    fixLayout () {
      setTimeout(() => {
        this._appStateProvider.updateLayout()
        this.gridster.resize();
        setTimeout(() => this._appStateProvider.updateLayout(), 300);
      }, 300);
    }

    ngAfterViewInit() {
        this._localize.applyTranslations(this._element.nativeElement);
        kendo.ui.progress($(".portfList-loading"), this._appStateProvider.fetchingPortfolioDetails);
        kendo.ui.progress($(".transList-loading"), this._appStateProvider.fetchingTransVolume);
        this.refreshPerfDetailsBarChart(this._insaService.chartDataPerformanceDetails);
        this.refreshTransVolume(this._insaService.transactionVolume);
        this.refreshPortfDetails(this._insaService.portfolioPerformanceDetails);
        this.hidePerformanceColumn();
        this.fixLayout();
        this.loadDashboardLayout();
    }

    ngOnDestroy() {
       this.appStateSubscription.unsubscribe();
       this.transVolumeSubscription.unsubscribe();
       this.portfPerfDetailsSubscription.unsubscribe();
       this.performanceDetailsChartSubscription.unsubscribe();
       this.reportSubscription.unsubscribe();
    }
}



// WEBPACK FOOTER //
// ./app/insa-components/insa-main/insa-main-widgets/newHome.component.ts